import { render, staticRenderFns } from "./McompatibilidadForm.vue?vue&type=template&id=88ed50ba"
import script from "./McompatibilidadForm.vue?vue&type=script&lang=js"
export * from "./McompatibilidadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports